import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../../core/services/settings.service';
import { EndpointResolverService } from '../../core/services/endpoint-resolver.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: '[app-footer]',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public version: string;
  constructor(public settings: SettingsService, private readonly epResolver: EndpointResolverService) {

  }

  public ngOnInit() {
    this.version = this.epResolver.getVersion();
  }

}
